const CheckStatus = require('../enums/check-status');
const GoodType = require('../enums/good-type');

/**
* Check
*/

class Check {

    constructor(document) {
        const data = document.data()

        this.uid = document.id
        this.createdAt = data.createdAt ? data.createdAt : new Date()
        this.address = data.address ? data.address : ''
        this.city = data.city ? data.city : ''
        this.country = data.country ? data.country : ''
        this.cover = data.cover ? data.cover : ''
        this.department = data.department ? data.department : ''
        this.goodType = data.goodType ? data.goodType : GoodType.VILLA
        this.comment = data.comment ? data.comment : ''
        this.participatingUserUID = data.participatingUserUID ? data.participatingUserUID : ''
        this.participatingUsername = data.participatingUsername ? data.participatingUsername : ''
        this.customerIdentity = data.customerIdentity ? data.customerIdentity : ''
        this.title = data.title ? data.title : ''
        this.status = data.status ? data.status : CheckStatus.UNDEFINED
        this.updatedAt = data.updatedAt ? data.updatedAt : new Date()
        this.zipCode = data.zipCode ? data.zipCode : ''
        this.hasReport = data.hasReport ? data.hasReport : false
    }

    get data() {
        return {
            uid: this.uid,
            createdAt: this.createdAt,
            address: this.address,
            city: this.city,
            country: this.country,
            cover: this.cover,
            department: this.department,
            goodType: this.goodType,
            participatingUserUID: this.participatingUserUID,
            participatingUsername: this.participatingUsername,
            title: this.title,
            status: this.status,
            updatedAt: this.updatedAt,
            customerIdentity: this.customerIdentity,
            zipCode: this.zipCode,
            hasReport: this.hasReport
        }
    }

    reportStoragePath() {
        return "reports/Rapport-" + this.uid.substring(0, 4) + '-' + this.participatingUsername + '-' + this.title + ".pdf"
    }

}

export default Check;